function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'lily-pad': 'rgb(37, 157, 96)','robin-egg-blue': 'rgb(184, 202, 217)','pond-green': 'rgb(118, 125, 100)','ash-gray': 'rgb(203, 203, 203)','dark-woods': 'rgb(26, 68, 60)','evening-blue': 'rgb(55, 72, 90)','creek-stone': 'rgb(224, 225, 218)','mushroom': 'rgb(110, 108, 104)','deep-lake-blue': 'rgb(44, 147, 206)','storm-gray': 'rgb(113, 115, 118)','midnight-black': 'rgb(17, 17, 17)','dove-gray': 'rgb(212, 213, 215)','pitch-black': 'rgb(0, 0, 0)','badger': 'rgb(221, 221, 221)','sparrow-gray': 'rgb(209, 211, 212)','raven': 'rgb(9, 9, 9)','jay-blue': 'rgb(28, 35, 86)','mountain-gray': 'rgb(88, 89, 91)','spring-water-blue': 'rgb(29, 184, 197)','morning-sun': 'rgb(238, 203, 111)','alpine': 'rgb(81, 104, 82)','storm-cloud': 'rgb(59, 61, 61)',};

    this.images = {'badger': 'url("//www.wildentrail.com/cdn/shop/files/badger_68x.png?v=14022298506115986432")',};

    this.triggers = ['color',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
